import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LottieLoaderComponent } from "./lottie-loader.component";
import { LottieModule } from "ngx-lottie";

@NgModule({
  declarations: [LottieLoaderComponent],
  imports: [CommonModule, LottieModule],
  exports: [LottieLoaderComponent],
})
export class LottieLoaderModule {}
